import { DynamicAutocompleteField } from "components/formFields/DynamicAutocompleteField";

import { i18n } from "services/i18nService";
import { fetchClasses } from "services/utility/class";

import { useClasses } from "hooks/useClasses";

export function FrmClass(props) {
  const {
    value,
    onValueChange,
    maxWidth,
    label = i18n("frmLabel.Class"),
  } = props;
  const { classes, classesCount } = useClasses();

  return (
    <DynamicAutocompleteField
      options={classes}
      optionsCount={classesCount}
      fetchFn={fetchClasses}
      fullWidth
      name="class"
      label={label}
      onValueChange={onValueChange}
      value={value}
      maxWidth={maxWidth}
    />
  );
}
